import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icons' // icon
import './assets/iconfont.css'
import axios from 'axios';
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
const app = new Vue({
  router,
  store,
  render: h => h(App)
})
import httpInterceptor from './network/interceptor'
Vue.use(httpInterceptor,app)

import httpApi from './network/api/index'
Vue.use(httpApi,app)

app.$mount('#app')